import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  ReCaptchaV3Provider,
} from "firebase/app-check";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_CONFIG_API_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_CONFIG_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaEnterpriseProvider(
    process.env.REACT_APP_FIREBASE_STORAGE_RECAPTCHA
  ),
  isTokenAutoRefreshEnabled: true,
});

// initializeAppCheck(firebaseApp, {
//   provider: new ReCaptchaV3Provider("6Lc_-RwgAAAAAHIvLNqIR23jEevAryNmW1bxbhVn"),
//   isTokenAutoRefreshEnabled: true,
// });

// export const loginPromise = signInWithEmailAndPassword(
// export const loginPromise = async () => {
//   try {
//     if (!auth.currentUser) {
//       await signInWithEmailAndPassword(auth, "biz@pkindev.com", "u5211904");
//     }

//     return new Promise((resolve) => {
//       const unsubscribe = onAuthStateChanged(auth, (user) => {
//         if (user) {
//           unsubscribe();
//           resolve(user);
//         }
//       });
//     });
//   } catch (error) {
//     console.error("❌ Firebase login failed:", error.code, error.message);
//     return null;
//   }
// };

// helpers/Firebase.js

let cachedUser = null; 

export const loginPromise = () => {
    return new Promise((resolve, reject) => {
        if (cachedUser) {
            return resolve(cachedUser);
        }

        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            unsubscribe();
            if (user) {
                // console.log(user);
                  
                cachedUser = user; 
                resolve(user);
            } else {
                try {
                    const result = await signInWithEmailAndPassword(
                        auth,
                        process.env.REACT_APP_FIREBASE_AUTH_MAIL,
                        process.env.REACT_APP_FIREBASE_AUTH_PASSWORD
                    );
                    // console.log(result);
                    cachedUser = result.user; 
                    resolve(result.user);
                } catch (err) {
                    reject(err);
                }
            }
        });
    });
};

export const logoutFirebase = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("❌ Firebase logout failed:", error.code, error.message);
  }
};

export const storage = getStorage(
  firebaseApp,
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
);
export const firebaseLoginReady = loginPromise;
export { auth };
